import React from 'react';
import '../../../css/dm-button.css' /* better if not declared as global -> should be css modules*/

class DMButton extends React.Component {

  render() {

    const { text, name, onClick, className, disabled, children, type, value, eventName } = this.props;

    return <button disabled={disabled}
      data-event={eventName}
      className={`DMButton btn btn-block btn-default ${className !== undefined ? className : ""}`}
      name={name !== undefined ? name : undefined}
      type={type}
      value={value}
      {...this.props.attributes}
      onClick={onClick}>
      {text}
      {children}
    </button>
  }
}

export default DMButton;
